import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/Logo";
import { useCategories } from "@/lib/api";

export const MobileMenu = ({ open, onOpenChange, links }) => {
  const cats = (useCategories() || []).filter((c) => c.count > 0);
  const close = () => onOpenChange(false);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[85vw] max-w-sm border-slate-200 bg-white text-slate-900" data-testid="mobile-menu">
        <SheetHeader><SheetTitle className="text-left"><Logo /></SheetTitle></SheetHeader>
        <nav className="mt-8 flex flex-col gap-1">
          {links.map(([to, label]) => (
            <Link key={to} to={to} onClick={close} className="rounded-lg px-3 py-3 font-display text-lg font-semibold hover:bg-slate-100" data-testid={`mobile-nav-${label.toLowerCase()}`}>
              {label}
            </Link>
          ))}
        </nav>
        <p className="mt-8 px-3 text-[10px] font-semibold uppercase tracking-[0.3em] text-[#0066FF]">Categorie</p>
        <div className="mt-3 flex flex-col">
          {cats.map((c) => (
            <Link key={c.slug} to={`/categoria/${c.slug}`} onClick={close} className="flex justify-between rounded-lg px-3 py-2.5 text-sm text-slate-700 hover:bg-slate-100">
              <span>{c.parent_path ? `— ${c.name}` : c.name}</span>
              <span className="font-mono text-xs text-slate-400">{c.count}</span>
            </Link>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};
